import { useState, useEffect } from "react";
import "./blogs.css";
// import { BlogsDataTable } from "views/admin/default/variables/columnsData";
// import tableDataComplex from "../default/variables/tableDataComplex.json";
// import ComplexTable from "views/admin/default/components/ComplexTable";
import { getAllBlog } from "proxyUrl";
import BlogTable from "./BlogTable";
// import { GetBookingDataByUserId } from "proxyUrl";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import axios from "axios";

const BLOG_TYPE_OPTIONS = [
  { value: "", label: "All Types" },
  { value: "1", label: "Creed Infotech" },
  { value: "2", label: "Ceddstaffing" },
  { value: "3", label: "Virtual Educare" },
];

const Blogs = () => {
  const [blogData, setBlogData] = useState("");
  const [filters, setFilters] = useState({
    type: "",
    title: "",
  });

  const currentUser = useSelector((state) => state.user.user.userRole.name);
  console.log(currentUser);

  const fetchData = (currentFilters) => {
    const params = new URLSearchParams();
    if (currentFilters.type) params.append("type", currentFilters.type);
    if (currentFilters.title?.trim()) params.append("title", currentFilters.title.trim());

    const url = params.toString() ? `${getAllBlog}?${params.toString()}` : getAllBlog;

    axios
      .get(url, { withCredentials: true })
      .then((res) => {
        setBlogData(res.data);
      })
      .catch((err) => {
        console.error("Blog API error:", err);
      });
  };

  useEffect(() => {
    fetchData(filters);
  }, [filters]);
  // console.log(user.length);
  return (
    <>
      <div className=" add-booking-header  relative  mx-4 mt-6 flex justify-between rounded-2xl bg-indigo-600 p-3 shadow-lg dark:bg-navy-800">
        <div className="text-xl font-bold text-white  dark:text-white">
          All Blog
        </div>
        <Link to="/admin/blogs/add">
          <button className="rounded-full bg-white p-1  px-3 text-navy-800 dark:bg-navy-900 dark:text-white">
            Add Blog
          </button>
        </Link>
      </div>

      {/* Filters Section */}
      <div className="mx-4 mt-4 mb-4 rounded-xl border border-gray-200 bg-white p-5 shadow-sm dark:border-navy-600 dark:bg-navy-800">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:gap-3">
          <select
            value={filters.type}
            onChange={(e) => setFilters({ ...filters, type: e.target.value })}
            className="w-full flex-1 min-w-0 rounded-xl border border-gray-300 bg-white px-3 py-2.5 text-sm text-gray-900 focus:border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500/20 dark:border-navy-600 dark:bg-navy-900 dark:text-white sm:basis-0"
          >
            {BLOG_TYPE_OPTIONS.map((opt) => (
              <option key={opt.value || "all"} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
          <input
            type="text"
            placeholder="Search by title..."
            value={filters.title}
            onChange={(e) => setFilters({ ...filters, title: e.target.value })}
            className="w-full flex-1 min-w-0 rounded-xl border border-gray-300 bg-white px-3 py-2.5 text-sm text-gray-900 placeholder-gray-500 focus:border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500/20 dark:border-navy-600 dark:bg-navy-900 dark:text-white dark:placeholder-gray-400 sm:basis-0"
          />
          <button
            onClick={() => setFilters({ type: "", title: "" })}
            className="rounded-xl border border-gray-300 bg-white px-4 py-2.5 text-sm font-semibold text-gray-700 transition-colors hover:bg-gray-50 dark:border-navy-600 dark:bg-navy-900 dark:text-white dark:hover:bg-navy-700"
          >
            Clear filters
          </button>
        </div>
      </div>

      <div className="relative -mt-7  grid w-full grid-cols-1 gap-5 md:grid-cols-1">
        {/* <TotalSpent /> */}
        {/* <WeeklyRevenue /> */}
        {blogData ? (
          <>
          <BlogTable
            columnLenghth={blogData.length}
            tableData={blogData}
            editRoute={`/admin/blogs/edit`}
            deleteRoute={`/admin/blogs/delete`}
          />
        </>
        ) : (
          <></>
        )}
      </div>
    </>
  );
};

export default Blogs;
